var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './dialog.styles';
import { dictionary } from '@mf-cms/helpers';
import { ifDefined } from 'lit/directives/if-defined.js';
let PDialog = class PDialog extends LitElement {
    constructor() {
        super(...arguments);
        this.culture = 'en-GB';
    }
    static { this.styles = styles; }
    /**
     * Show dialog
     * @returns {void}
     */
    open() {
        this.dialog.showModal();
        this.dispatchEvent(new CustomEvent('p-dialog-open', { bubbles: true, composed: true }));
        if (this.disableBodyScroll) {
            document.body.classList.add('disable-scroll');
        }
    }
    /**
     * Close dialog
     * @returns {void}
     */
    close() {
        this.dialog.close();
        if (this.disableBodyScroll) {
            document.body.classList.remove('disable-scroll');
        }
    }
    /**
     * On close
     * @returns {void}
     */
    onClose() {
        this.dispatchEvent(new CustomEvent('p-dialog-close', { bubbles: true, composed: true }));
    }
    /**
     * Toggle dialog
     * @returns {void}
     */
    isOpen() {
        return this.dialog.open;
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        const classes = {
            drawer: this.drawer,
            'full-size': this.fullSize
        };
        return html ` <dialog aria-labelledby=${ifDefined(!this.hideHeader ? `dialog-${this.dialogId}-label` : null)}
        aria-label=${ifDefined(this.hideHeader ? this.heading : null)}
        @close=${this.onClose}
        class=${classMap(classes)}
      >
        ${!this.hideHeader
            ? html ` <div class="header"> <h2 id="dialog-${this.dialogId}-label">${this.heading}</h2> <p-button size="small" @p-click=${this.close} color="ghost" icon label=${dictionary(this.culture, 'dialog', 'close')} > <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16" > <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" /> </svg> </p-button> </div> `
            : ''}
        <div class="body">
          <slot></slot>
        </div>
        <div class="footer">
          <slot name="footer"></slot>
        </div>
      </dialog>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true })
], PDialog.prototype, "heading", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'dialog-id' })
], PDialog.prototype, "dialogId", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PDialog.prototype, "drawer", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'full-size' })
], PDialog.prototype, "fullSize", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'hide-header' })
], PDialog.prototype, "hideHeader", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'disable-body-scroll' })
], PDialog.prototype, "disableBodyScroll", void 0);
__decorate([
    property({ type: String })
], PDialog.prototype, "culture", void 0);
__decorate([
    query('dialog')
], PDialog.prototype, "dialog", void 0);
PDialog = __decorate([
    customElement('p-dialog')
    /**
     * PDialog component
     *
     * @class PDialog
     * @typedef {PDialog}
     * @extends {LitElement}
     */
], PDialog);
export { PDialog };
